import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root.js";

export const cancelBookingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/cancel/$token",
  component: lazyRouteComponent(() => import("./cancel-booking.page.js"), "CancelBookingPage"),
});
